import React from 'react';
import ZeroCommentsEmptyState from '../../empty-states/zero-comments-empty-state';
import CommentingLockedEmptyState from '../../empty-states/commenting-locked-empty-state';
import RootCommentBox from '../comment-box/root-comment-box';
import { unreachable } from '../../../ts-utils';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { useApi } from '../../context/api-context/use-api';
import { getIsSSR, getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { HorizontalDivider } from '../dividers';
import { resolveSomeoneIsTyping } from './resolve-someone-is-typing';
import { DummyCommentBox } from '../comment-box';
import { CommentsSort } from '../comments-sort/comments-sort';
import { st, classes } from './start-root-box-section.st.css';
import { usePermissions } from '../../context/permissions-context/use-permissions';
const StartRootBoxSectionNoMemo = ({ isListEmpty, someoneIsTyping, appHeaderIsVisible, shouldShowCommentBox, boxRating, ...sortProps }) => {
    const { hideZeroCommentsEmptyState, hideHeaderDivider, resourceId } = useConfiguration();
    const { getPermission } = usePermissions();
    const { loginRequiredDev, someoneIsTypingDev, isSSR, isMobile, biAttemptLoginSignup, requestLoginAction, } = useApi((state, actions, _, ctx) => ({
        loginRequiredDev: ctx.wcDevToolsState.specialStates === 'login_required',
        someoneIsTypingDev: ctx.wcDevToolsState.showSomeoneIsTyping,
        isSSR: getIsSSR(state),
        isMobile: getIsMobile(state),
        biAttemptLoginSignup: actions.biAttemptLoginSignup,
        requestLoginAction: actions.requestLogin,
    }));
    const requestLogin = () => {
        biAttemptLoginSignup({ type: 'login', resourceId });
        requestLoginAction({ mode: 'login' });
    };
    const shouldShowDivider = appHeaderIsVisible && !hideHeaderDivider;
    const renderSort = () => sortProps.hideSort ? null : (React.createElement(CommentsSort, { className: classes.sort, selectedSort: sortProps.selectedSort }));
    const addCommentPermission = getPermission({ action: 'CREATE_COMMENT' });
    return (React.createElement("div", { className: st(classes.root, {
            isMobile,
            withTopMargin: appHeaderIsVisible && !!hideHeaderDivider,
            withoutCommentBox: !shouldShowCommentBox,
        }) },
        shouldShowDivider ? React.createElement(HorizontalDivider, { className: classes.divider, type: "header" }) : null,
        (() => {
            if (loginRequiredDev) {
                return [
                    shouldShowCommentBox && (React.createElement(DummyCommentBox, { className: classes.commentBox, onClick: requestLogin })),
                    renderSort(),
                ];
            }
            if (addCommentPermission.type === 'ALLOW') {
                return (React.createElement(React.Fragment, null,
                    shouldShowCommentBox ? (React.createElement(React.Fragment, null,
                        React.createElement(RootCommentBox, { className: classes.commentBox, position: "start", shoudDispatchIAmTyping: addCommentPermission.precondition === 'NONE' ||
                                addCommentPermission.precondition === 'GUEST_FLOW', withGuestFlow: addCommentPermission.precondition === 'GUEST_FLOW', canRate: getPermission({ action: 'RATE' }).type === 'ALLOW', boxRating: boxRating }),
                        renderSort(),
                        !isSSR &&
                            resolveSomeoneIsTyping('start', someoneIsTypingDev, someoneIsTyping),
                        ' ',
                        !shouldShowCommentBox && renderSort())) : null,
                    isListEmpty && !hideZeroCommentsEmptyState && React.createElement(ZeroCommentsEmptyState, null)));
            }
            switch (addCommentPermission.reason) {
                case 'LOCKED':
                    return [
                        shouldShowCommentBox && (React.createElement("div", { className: classes.lockedState },
                            React.createElement(CommentingLockedEmptyState, null))),
                        renderSort(),
                    ];
                case 'LOGIN_REQUIRED':
                    return [
                        shouldShowCommentBox && (React.createElement(DummyCommentBox, { className: classes.commentBox, onClick: requestLogin })),
                        renderSort(),
                    ];
                case 'UNKNOWN':
                    return null;
                default:
                    throw unreachable(addCommentPermission.reason);
            }
        })()));
};
const StartRootBoxSection = React.memo(StartRootBoxSectionNoMemo);
export default StartRootBoxSection;
//# sourceMappingURL=start-root-box-section.js.map